<header id="myHeader">
    <div class="d-flex align-items-stretch me-3 menu-header">
        <div class="haederlogo">
            <a style="margin-left: 25px; margin-right: 25px">
                <img alt="Logo" src="./assets/media/logos/{{ IA }}" class="logo-sticky" style="height: 60px" />
            </a>
        </div>

        <ng-container *ngIf="headerMenuSelfDisplay" class="mobile_menu">
            <button class="btn p-0 burger-icon burger-icon-left ms-4" id="kt_header_mobile_toggle">
                <span></span>
            </button>
        </ng-container>

        <ng-container>
            <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
                <ng-container>
                    <div #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-left header-menu-mobile" [ngClass]="headerMenuCSSClasses">
                        <ul class="menu-nav" [ngClass]="ulCSSClasses">
                            <li class="menu-item menu-item-rel" *ngIf="displaySelectOrganization">
                                <div class="menu_class">
                                    <a class="menu-link menu-padding" (click)="navigateUrl('Home')">
                                        {{ 'SETTING_PAGE.IDMS_SETTINGS.SELECT_ORGANIZATION' | transloco }}</a
                                    >
                                </div>
                            </li>
                            <li class="menu-item menu-item-rel" *ngIf="isIdmsVisible === true">
                                <div class="menu_class">
                                    <a class="menu-link menu-padding" [class.disabled]="disabled === false" (mouseover)="showIdms()" (mouseout)="notIdms()">
                                        <!-- Project Assured -->
                                        {{ 'HOME_PAGE.HEADER.MENU_TEXT.PROJECT_ASSURED' | transloco }}
                                        <ng-container *ngIf="rootArrowEnabled">
                                            <i class="menu-arrow"></i>
                                        </ng-container>
                                    </a>
                                </div>
                            </li>

                            <div class="nav_menu one" id="one" (mouseover)="showIdms()" (mouseout)="notIdms()">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="idms_details">
                                            <a href="javascript:void(0)"><img src="./assets/media/logos/{{ PA }}" alt="" /></a>
                                            <h3>
                                                <!-- Project Assured -->
                                                {{ 'HOME_PAGE.HEADER.MENU_TEXT.PROJECT_ASSURED' | transloco }}
                                            </h3>
                                            <p>
                                                {{ 'HOME_PAGE.HEADER.IDMS_DROPDOWN.DESCRIPTION' | transloco }}
                                            </p>

                                            <p *ngIf="displaySelectOrganization">
                                                <a (click)="navigateUrl('Home')"> {{ 'SETTING_PAGE.IDMS_SETTINGS.SELECT_ORGANIZATION' | transloco }}</a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="idms_menu">
                                            <ul>
                                                <li style="cursor: pointer" *ngIf="isDashboardVisible">
                                                    <a (click)="navigateUrl('Dashboard')">
                                                        {{ 'HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.DASHBOARD' | transloco }}
                                                    </a>
                                                </li>
                                                <li *ngIf="isPlantManager" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Plant Manager')">{{
                                                        'HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.PLANT_MANAGER' | transloco
                                                    }}</a>
                                                </li>
                                                <li *ngIf="isprojectManger" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Project Manager')">
                                                        <!-- Project Manager -->

                                                        {{ 'HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.PROJECT_MANAGER' | transloco }}
                                                    </a>
                                                </li>
                                                <li *ngIf="isReports" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Reports')">
                                                        <!-- Reports -->
                                                        {{ 'HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.REPORTS' | transloco }}
                                                    </a>
                                                </li>
                                                <li *ngIf="isReports" style="cursor: pointer">
                                                    <a (click)="barcodePopUp()">
                                                        <!-- Barcode Scanning -->
                                                        {{ 'HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.BAR_CODE_SCANNING' | transloco }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <li class="menu-item menu-item-rel" *ngIf="isInformateVisible">
                                <div class="menu_class">
                                    <a
                                        class="menu-link menu-padding"
                                        [class.disabled]="disabled === false"
                                        (mouseover)="showInformate()"
                                        (mouseout)="notInformate()"
                                        *ngIf="isInformateVisible"
                                    >
                                        <!-- Joint Assured -->
                                        {{ 'HOME_PAGE.HEADER.MENU_TEXT.JOINT_ASSURED' | transloco }}
                                        <ng-container *ngIf="rootArrowEnabled">
                                            <i class="menu-arrow"></i>
                                        </ng-container>
                                    </a>
                                </div>
                            </li>
                            <div class="nav_menu1 two" id="two" (mouseover)="showInformate()" (mouseout)="notInformate()">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="idms_details">
                                            <img src="./assets/media/logos/{{ JA }}" alt="" height="60px" />
                                            <h3>
                                                <!-- Joint Assured -->
                                                {{ 'HOME_PAGE.HEADER.MENU_TEXT.JOINT_ASSURED' | transloco }}
                                            </h3>
                                            <p>
                                                {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.DESCRIPTION' | transloco }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="informate_menu">
                                            <ul>
                                                <li *ngIf="isStandardFlange" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Standard Flange')">{{
                                                        'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.STANDARD_FLANGE' | transloco
                                                    }}</a>
                                                </li>
                                                <li *ngIf="isCustomFlange" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Custom Flange')">{{
                                                        'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.CUSTOM_FLANGE' | transloco
                                                    }}</a>
                                                </li>
                                                <li *ngIf="isClamp" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Clamp')">{{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.CLAMP' | transloco }}</a>
                                                </li>
                                                <li *ngIf="isEngineeredJointVisible" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Engineered Joint')">{{
                                                        'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.ENGINEERED_JOINT' | transloco
                                                    }}</a>
                                                </li>
                                                <li *ngIf="isMatrixVisible === true" style="cursor: pointer">
                                                    <a (click)="navigateUrl('Matrix')">{{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.MATRIX' | transloco }}</a>
                                                </li>
                                                <li *ngIf="isIceDatabaseVisible" style="cursor: pointer">
                                                    <a class="menu-link" routerLink="/informate/icedatabase" [routerLinkActive]="['active']">
                                                        <span class="menu-text">
                                                            {{ 'HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.ICE_DATABASE' | transloco }}
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="nav_menu one" id="three">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="idms_details">
                                            <a (click)="navigateUrl('organization')">
                                                {{ 'SETTING_PAGE.IDMS_SETTINGS.SELECT_ORGANIZATION' | transloco }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <li class="menu-item menu-item-rel" *ngIf="displayCDMS">
                                <div class="menu_class">
                                    <a class="menu-link menu-padding" (click)="navigateUrl('Home')" (mouseover)="showCDMS()" (mouseout)="notCDMS()">
                                        {{ 'SETTING_PAGE.IDMS_SETTINGS.COMPETENCY_ASSURED' | transloco }}
                                    </a>
                                </div>
                            </li>
                            <div *ngIf="displayCDMSLinks" class="nav_menu cdms" id="cdms" (mouseover)="showCDMS()" (mouseout)="notCDMS()">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="idms_details">
                                            <a href="javascript:void(0)"><img src="./assets/media/logos/{{ CA }}" alt="cdms" /> </a>
                                            <h3>
                                                {{ 'SETTING_PAGE.IDMS_SETTINGS.COMPETENCY_ASSURED' | transloco }}
                                            </h3>
                                            <p>
                                                {{ 'SETTING_PAGE.IDMS_SETTINGS.DESCRIPTION' | transloco }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="idms_menu">
                                            <ul>
                                                <li style="cursor: pointer">
                                                    <a (click)="navigateUrl('CDMS_Dashboard')">{{ 'SETTING_PAGE.IDMS_SETTINGS.DASHBOARD' | transloco }}</a>
                                                </li>
                                                <li style="cursor: pointer">
                                                    <a (click)="navigateUrl('CDMS_TrainingUnits')">{{
                                                        'SETTING_PAGE.IDMS_SETTINGS.TRAINING_UNITS' | transloco
                                                    }}</a>
                                                </li>
                                                <li style="cursor: pointer">
                                                    <a (click)="navigateUrl('CDMS_Personnel')">{{ 'SETTING_PAGE.IDMS_SETTINGS.PERSONNEL' | transloco }}</a>
                                                </li>
                                                <li style="cursor: pointer">
                                                    <a (click)="navigateUrl('CDMS_Reports')">{{ 'SETTING_PAGE.IDMS_SETTINGS.REPORTS' | transloco }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</header>
